import * as React from "react";

interface PropsCardDrawWinner {
  title: string;
  category: string;
  school: string;
  place: string;
  image: string;
}

const CardDrawWinner: React.FC<PropsCardDrawWinner> = ({title, category , school, place, image}) => {
  return (
    <div className="cardDrawWinner">
  
      <picture className="cardDrawWinner__picture">
        <img className="cardDrawWinner__picture--draw" src={`${image}`} />
      </picture>

      <div className="cardDrawWinner__info">
        <h3 className="cardDrawWinner__info--title">{title}</h3>
        <p className="cardDrawWinner__info-category">{category}</p>
        <p className="cardDrawWinner__info-school">{school}</p>
        <p className="cardDrawWinner__info-place">{place}</p>
      </div>

    </div>
  )
}

export default CardDrawWinner;